export const isMobile = () =>  {
  try {
    const ua = navigator.userAgent;
    const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

    const isMobileUA = (
      (/android/i.test(ua) && /mobile/i.test(ua)) ||
            /iphone/i.test(ua) ||
            /windows phone/i.test(ua)
    );

    return isMobileUA && isTouchDevice && window.innerWidth <= 768;
  } catch (e){
    console.error('isMobile', e);
    return undefined;
  }
};